import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './i18n';
import { store } from 'redux_store/store.js';
import { Provider } from 'react-redux';

const Main = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <Suspense fallback={null}>
          <App />
        </Suspense>
      </Provider>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<Main />);
